import { useState, useEffect, useRef } from 'react';

/**
 * Anime un nombre de 0 vers `target` à chaque changement de valeur.
 * Utilise requestAnimationFrame + ease-out cubic.
 */
export function useCountUp(target: number, duration = 850): number {
  const [val, setVal] = useState(0);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isFinite(target) || target < 0) { setVal(target); return; }
    if (target === 0) { setVal(0); return; }

    const start = performance.now();

    const step = (now: number) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - t) ** 3; // ease-out cubic
      setVal(Math.round(eased * target));
      if (t < 1) rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [target, duration]);

  return val;
}
